<div class="session-modal-wrapper">
  <div class="session-modal" class="alert" role="dialog" id="modal-dialog-option" aria-labelledby="dialog-label" aria-modal="true"
    tabindex="-1">
    <div class="session-modal-header">
      <div class="session-modal-title " tabindex="0" [id]="'sessionTimeout-header'">
        <span *ngIf="isUserLogin" class="loggedInUserHeader">{{string_LoggingOutTimingWording}}</span>
        <span *ngIf="!isUserLogin">{{string_SessionClosingWording}}</span>
      </div> 
    </div>
    <div class="session-modal-content">
      <span class="timeCounter" id="msgContent" aria-labelledby="timeCounter">{{countDown | async}}</span>
    </div>
    <div class="clear-all login-register-div" #continueBtn tabindex="0">
      <button id="loginBtn" name="loginBtn" tabindex="0" (click)="continueSession()" class="session-button keepMeLoggedIn-btn pointer reflect" [ngClass]="{'keepMeLoggedInUser-btn':isUserLogin}">
        <span class="keepMeLoggedIn-text" id="loginText" aria-live="polite">
            <span *ngIf="!isUserLogin" aria-labelledby="continue with my session">{{string_ContinueSessionCTALabel}}</span>
            <span *ngIf="isUserLogin" aria-labelledby="keep me logged in">{{string_KeepLoggedInCTALabel}}</span>
        </span>
      </button>
      <div class="retriveQuote" *ngIf="!isUserLogin" #loginBtn tabindex="0">
        <span >If you want to retrieve your quote later, you will need to 
          <div style="display:inline-flex">
            <div #loginBtn>
                <a class="hyperLinkColor" (keyup.enter)="login()" (click)="login()" tabindex="0" aria-labelledby="login">login</a>
            </div>
            or 
            <div #registerBtn>
                <a (click)="registration()" (keyup.enter)="registration()" class="hyperLinkColor" tabindex="0" aria-labelledby="register">register</a>
            </div>
          </div>
          </span>
      </div>
      
      <div class="form-field  keepMeLogoutUser-btn" *ngIf="isUserLogin" #loginBtn tabindex="0">
        <a id="logoutLink" name="logoutLink" tabindex="0" class="keepMeLoggedIn-text logoutText" (keyup.enter)="logout()" (click)="logout()">Logout</a>
      </div>
    </div>
  </div>
</div>
